import React from 'react';
import PropTypes from 'prop-types';
import { Text, FlexGrid, Checkbox } from '@gasbuddy/react-components';
import Select from 'react-select';
import styles from './styles.css';
import { TIME_NOT_SELECTED } from '../../../../lib/constants/constants';
import { spawnDropDownHours } from './helpers';
import sharedStyles from '../../../styles/shared.css';

const dropdownHourOptions = spawnDropDownHours();

export default function EditDayOfTheWeek({ operationHours: operationHoursProps, onChange }) {
  const [operationHours, setOperationHours] = React.useState(operationHoursProps);
  const [selectedOpenTime, setSelectedOpenTime] = React.useState(dropdownHourOptions.find(o => o.value === operationHoursProps.open));
  const [selectedCloseTime, setSelectCloseTime] = React.useState(dropdownHourOptions.find(o => o.value === operationHoursProps.close));

  React.useEffect(() => {
    setOperationHours(operationHoursProps);
  }, [operationHoursProps]);

  React.useEffect(() => {
    setSelectedOpenTime(dropdownHourOptions.find(o => o.value === operationHours.open));
    setSelectCloseTime(dropdownHourOptions.find(o => o.value === operationHours.close));
  }, [operationHours]);

  const updateOpenCloseTime = (propName, newValue) => {
    const newHours = {
      ...operationHours,
      [propName]: newValue,
    };
    setOperationHours(newHours);
    onChange(newHours);
  };

  const updateOpen24AndCloseCheckBoxes = (newValue, openAllDay, closed) => {
    const newHours = {
      ...operationHours,
      openAllDay,
      closed,
      open: newValue ? TIME_NOT_SELECTED : operationHours.open,
      close: newValue ? TIME_NOT_SELECTED : operationHours.close,
    };

    setOperationHours(newHours);
    onChange(newHours);
  };

  const handleOnChange24HoursCheckbox = (newValue) => {
    updateOpen24AndCloseCheckBoxes(newValue, newValue, newValue ? false : operationHours.closed);
  };

  const handleOnChangeClosedCheckbox = (newValue) => {
    updateOpen24AndCloseCheckBoxes(newValue, newValue ? false : operationHours.openAllDay, newValue);
  };

  const handleOnChangeOpenTimeDropdown = (e) => {
    updateOpenCloseTime('open', e.value);
  };

  const handleOnChangeCloseTimeDropdown = (e) => {
    updateOpenCloseTime('close', e.value);
  };

  // eslint-disable-next-line no-unused-vars
  const resetState = oldOperationHours => setOperationHours(oldOperationHours);

  return (
    <>
      <FlexGrid className={styles.flexGridClassCenter}>
        <FlexGrid.Column mobile={12} tablet={2} className={styles.dayOfTheWeekForm}>
          <Text bold>
            {operationHours.day}
          </Text>
        </FlexGrid.Column>
        <FlexGrid.Column mobile={12} tablet={5} className={styles.dropDownHoursForm}>
          <Select
            key={`OpenTimeDD${operationHours.day}`}
            className={sharedStyles.rsSelect}
            classNamePrefix="react-select"
            options={dropdownHourOptions}
            defaultValue={selectedOpenTime}
            value={selectedOpenTime}
            onChange={handleOnChangeOpenTimeDropdown}
            isDisabled={operationHours.openAllDay || operationHours.closed}
          />
          <div className={styles.dropDownSeparator}>to</div>
          <Select
            key={`CloseTimeDD${operationHours.day}`}
            className={sharedStyles.rsSelect}
            classNamePrefix="react-select"
            options={dropdownHourOptions}
            defaultValue={selectedCloseTime}
            value={selectedCloseTime}
            onChange={handleOnChangeCloseTimeDropdown}
            isDisabled={operationHours.openAllDay || operationHours.closed}
          />
        </FlexGrid.Column>
        <FlexGrid.Column mobile={12} tablet={5} className={styles.checkBoxHoursForm}>
          <Checkbox
            label="Open 24 Hours"
            onChange={e => handleOnChange24HoursCheckbox(e.target.checked)}
            checked={operationHours.openAllDay}
          />
          <div className={styles.checkBoxSeparator} />
          {/* closed all day */}
          <Checkbox
            label="Closed"
            onChange={e => handleOnChangeClosedCheckbox(e.target.checked)}
            checked={operationHours.closed}
          />
        </FlexGrid.Column>
      </FlexGrid>
    </>
  );
}

EditDayOfTheWeek.propTypes = {
  operationHours: PropTypes.shape({
    day: PropTypes.string,
    open: PropTypes.string,
    close: PropTypes.string,
    openAllDay: PropTypes.bool,
    closed: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
